var _defs, _rect, _text, _text2, _text3, _path, _g, _g2, _g3, _g4, _rect2, _text4, _circle, _path2, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzOpportunitySpecificSuitabilityModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1120,
    height: 400,
    viewBox: "0 0 1120 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz opportunity-specific suitability model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tlossScore",
    x1: 838,
    y1: 40,
    x2: 1038,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3885"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tlossShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 18,
    floodColor: "#06142A",
    floodOpacity: 0.17
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1118,
    height: 398,
    rx: 30,
    fill: "#F8FBFF",
    stroke: "#C8DCF3",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 51,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.8
  }, "EVIDENCE MODEL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 82,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 800
  }, "Opportunity: Operations Analyst")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 105,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5
  }, "Each signal is evaluated against this opportunity context.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340 178C515 178 575 200 742 200M340 274C515 274 575 215 742 215M340 322C515 322 585 230 742 230",
    fill: "none",
    stroke: "#B8CDE5",
    strokeWidth: 2.5,
    strokeDasharray: "7 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 139,
    width: 312,
    height: 72,
    rx: 17,
    fill: "#FFFFFF",
    stroke: "#C6DDF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 175,
    r: 22,
    fill: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 169-6 6 6 6M91 169l6 6-6 6M88 162l-8 26",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 169,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 780
  }, "Technical competency"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 190,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Opportunity-specific assessment evidence"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 227,
    width: 312,
    height: 72,
    rx: 17,
    fill: "#FFFFFF",
    stroke: "#F0C4D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 263,
    r: 22,
    fill: "#FFF0F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 258,
    r: 5,
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 260,
    r: 4,
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 277c1-8 4-11 8-11s7 3 8 11M87 269c5-1 9 2 10 8",
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 257,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 780
  }, "Workplace awareness"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 278,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Configured for the role; not psychometric"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 315,
    width: 312,
    height: 56,
    rx: 17,
    fill: "#FFFFFF",
    stroke: "#C6DDF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 343,
    r: 20,
    fill: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 335,
    width: 14,
    height: 16,
    rx: 3,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 343 3 3 5-6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 338,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 780
  }, "Profile validity"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 358,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Evidence extracted from submitted documents"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tlossShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 214,
    r: 126,
    fill: "#07152A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 214,
    r: 104,
    fill: "none",
    stroke: "#2B537F",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 110a104 104 0 0 1 92 153",
    fill: "none",
    stroke: "url(#tlossScore)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 179,
    textAnchor: "middle",
    fill: "#80C4FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.5
  }, "SUITABILITY"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 231,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 52,
    fontWeight: 830
  }, "86"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 258,
    textAnchor: "middle",
    fill: "#C1CDDC",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "Opportunity-specific"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 142,
    width: 116,
    height: 145,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#C8DCF3"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 171,
    textAnchor: "middle",
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "CONTEXT LINK")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 214,
    r: 24,
    fill: "#FFF0F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1020 218-4 4a7 7 0 0 1-10-10l7-7a7 7 0 0 1 10 0M1032 210l4-4a7 7 0 0 1 10 10l-7 7a7 7 0 0 1-10 0M1018 220l17-17",
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 259,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 760
  }, "Not a generic")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 275,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 760
  }, "candidate score")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzOpportunitySpecificSuitabilityModel);
export default __webpack_public_path__ + "static/media/talentlenz-opportunity-specific-suitability-model.c95a3468921ded0b2e45961fabc153fa.svg";
export { ForwardRef as ReactComponent };